var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sl-content',{attrs:{"pagetype":"4","pagename":"slintelligentsystems","title":_vm.$t('sl.si.title'),"titlecolor":"blue"}})}
var staticRenderFns = []

export { render, staticRenderFns }